import React from 'react';
import Hero from './components/IQAC/proceeding-AC-BOS/Hero';
import Main from './components/IQAC/proceeding-AC-BOS/Main';

const IqacProceedingACBOS = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default IqacProceedingACBOS;